var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2875 5.86806C3.1375 6.04398 2.8625 6.04398 2.7125 5.86806L0.1125 3.25445C-0.0375 3.10366 -0.0375 2.85236 0.1125 2.70157L0.6875 2.12356C0.8375 1.97277 1.0875 1.97277 1.2375 2.12356L3.0125 3.88272L6.7625 0.113089C6.9125 -0.0376963 7.1625 -0.0376963 7.3125 0.113089L7.8875 0.6911C8.0375 0.841885 8.0375 1.09319 7.8875 1.24398L3.2875 5.86806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.61f9c37e783d4f468be82cf2b021dbaa.svg";
export { ForwardRef as ReactComponent };